import apiClient from "./config";
import { API_KEY_ENDPOINTS } from "./endpoints";

export const getAPIKey = () => apiClient.get(API_KEY_ENDPOINTS.GET_API_KEY);

